/* eslint-disable @typescript-eslint/no-explicit-any */
import { SyliusAddress } from '@/lib/types/SyliusAddress';
import { isNotEmptyObject } from '@/lib/functions/isNotEmptyObject';

export async function setUserAddress(
  id: number | undefined,
  address: SyliusAddress,
  accessToken: string
): Promise<any> {
  try {
    // Helper function to determine the fetch parameters
    const createOrUpdateAddress = async (): Promise<Response> => {
      const url = id
        ? `${process.env.NEXT_PUBLIC_SITE_URL}/api/address/${id}/`
        : `${process.env.NEXT_PUBLIC_SITE_URL}/api/address/`;
      const method = id ? 'PUT' : 'POST';

      return fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(address),
      });
    };

    const response = await createOrUpdateAddress();

    switch(response?.status) {
      case 200:
      case 201: {
        const data = await response.json();
        if (data && isNotEmptyObject(data)) {
          return { 'success': true, 'message': '', 'data': data };
        }
        return { 'success': false, 'message': 'Profile not found in response', 'data': null };
      }
      case 400: {
        const data = await response.json();
        return { 'success': false, 'message': data.error ?? '', 'data': null };
      }
      default: {
        return {'success': false, 'message': 'Unknown error', 'data': null};
      }
    }
  }
  catch {
    return {'success': false, 'message': '', 'data': null};
  }
}
